import { useContext } from "react";
import {
  NotesAndPicturesContext,
  type NotesAndPicturesContextValue,
} from "../context/NotesAndPicturesContext";

export function useNotesAndPictures(): NotesAndPicturesContextValue {
  const ctx = useContext(NotesAndPicturesContext);
  if (!ctx) {
    throw new Error(
      "useNotesAndPictures must be used within NotesAndPicturesProvider",
    );
  }
  return ctx;
}
